var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block hover:bg-gray-200 my-1 px-4 py-1 font-medium text-gray-800 cursor-pointer",on:{"click":_vm.onClickDropdownItem}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }